import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import AlliedInitiateProposalPageStore, {
  AlliedInitiateProposalPageStoreContext,
  useAlliedInitiateProposalPageStore,
} from 'store/pages/initiate-quote/allied/pageStore';
import AlliedInitiateProposalForm from 'components/initiate-quote/Allied';
import InitiateProposalPageLayout from 'components/common/initiate-proposal/InitiateProposalPageLayout';
import QuoteExperienceStep from 'components/common/initiate-proposal/QuoteExperienceStep';
import FavoriteQuoteStep from 'components/common/initiate-proposal/FavoriteQuoteStep';

const PageContent: React.FC = observer(() => {
  const {
    initiateQuoteFlowDelegate,
    bulletTabsDelegate,
    basicInfoStepController,
    proposalExperienceStepController,
    favoriteProposalStepController,
    proposalExperience,
    getInitialData,
  } = useAlliedInitiateProposalPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <InitiateProposalPageLayout
      initiateQuoteFlowDelegate={initiateQuoteFlowDelegate}
      bulletTabsDelegate={bulletTabsDelegate}
      tabs={[
        <AlliedInitiateProposalForm key="0" basicInfoStepController={basicInfoStepController} />,
        <QuoteExperienceStep
          key="1"
          formController={proposalExperienceStepController.form}
          experiences={proposalExperienceStepController.experiences}
          experienceDisabledReasons={proposalExperienceStepController.experienceDisabledReasons}
          experienceAccessLimitations={proposalExperienceStepController.experienceAccessLimitations}
          renewalActionsDelegate={proposalExperienceStepController.renewalActionsDelegate}
        />,
        proposalExperience === 'FAVORITE' && (
          <FavoriteQuoteStep key="2" favoriteProposalStepController={favoriteProposalStepController} />
        ),
      ].filter(Boolean)}
    />
  );
});

const AlliedInitiateProposalPage: React.FC = () => {
  const { groupId } = useParams<{ groupId: string }>();

  const pageStore = useMemo(() => new AlliedInitiateProposalPageStore({ groupId }), [groupId]);

  return (
    <AlliedInitiateProposalPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </AlliedInitiateProposalPageStoreContext.Provider>
  );
};

export default AlliedInitiateProposalPage;
